// extracted by mini-css-extract-plugin
module.exports =  {"alert":"hyUgMrUR","danger":"LDhrhhDU","icon":"gjaFTqv8","info":"DLBXZEYp","confirmation":"jzkRJvDG","heading":"fg_10Eze","subText":"f27LMP7b","buttonContainer":"z2dtZ5YA"};